import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class AgendaEquipmentOptionDto {
  id: Scalars['String'];
  name: Scalars['String'];
};

export class AgendaGridBlockDto {
  equipmentId: Scalars['String'];
  equipmentName: Scalars['String'];
  itemType: AgendaItemType;
  kind: Scalars['String'];
  lines: Array<AgendaGridLineDto>;
  occurrenceId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalHours: Scalars['Int'];
};

export class AgendaGridDayDto {
  blocks: Array<AgendaGridBlockDto>;
  date: Scalars['String'];
  month: Scalars['String'];
  weekDay: Scalars['String'];
};

export class AgendaGridEquipmentDto {
  days: Array<AgendaGridDayDto>;
  equipmentId: Scalars['String'];
  equipmentName: Scalars['String'];
  occurrences: Array<AgendaOccurrenceItemDto>;
  totalDaysWithOccurrence: Scalars['Int'];
  totalOccurrenceHours: Scalars['Int'];
};

export class AgendaGridLineDto {
  description?: Maybe<Scalars['String']>;
  hours: Scalars['Int'];
  isAutomatic?: Maybe<Scalars['Boolean']>;
  lotCode?: Maybe<Scalars['String']>;
  lotId?: Maybe<Scalars['String']>;
  opNumber?: Maybe<Scalars['String']>;
};

export class AgendaGridStageDto {
  equipments: Array<AgendaGridEquipmentDto>;
  stageIcon: Scalars['String'];
  stageId: Scalars['String'];
  stageName: Scalars['String'];
  stageOrder: Scalars['Int'];
};

/** Tipos de blocos na agenda de produção */
export enum AgendaItemType {
  Advance = 'ADVANCE',
  Delay = 'DELAY',
  Lot = 'LOT',
  Maintenance = 'MAINTENANCE',
  Pause = 'PAUSE',
  Setup = 'SETUP'
}

export class AgendaOccurrenceItemDto {
  date: Scalars['String'];
  hours: Scalars['Int'];
  notes: Array<AgendaOccurrenceNoteDto>;
  title: Scalars['String'];
};

export class AgendaOccurrenceNote {
  agendaItem: ProductionAgendaItem;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class AgendaOccurrenceNoteDto {
  createdAt: Scalars['DateTime'];
  createdByName: Scalars['String'];
  createdByPhotoUrl?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export class AgendaStageOptionDto {
  id: Scalars['String'];
  name: Scalars['String'];
};

export class AuthInput {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  redirectUri: Scalars['String'];
};

export class AuthType {
  token: Scalars['String'];
  user: User;
};

export class Country {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  unity?: Maybe<Array<Unity>>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
};

export class CountryPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Country>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CreateCountryInput {
  flag?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export class CreateEquipmentInput {
  hasScale?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  sectorId?: InputMaybe<Scalars['String']>;
  setupPartial?: InputMaybe<Scalars['Float']>;
  setupTotal?: InputMaybe<Scalars['Float']>;
  shiftsQuantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EquipmentStatus>;
  tag?: InputMaybe<Scalars['String']>;
  toolIds?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Scalars['String']>;
  viaType?: InputMaybe<ViaType>;
};

export class CreateOccurrenceInput {
  equipmentId: Scalars['ID'];
  hours: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  productionDate: Scalars['DateTime'];
  sequenceStageId?: InputMaybe<Scalars['ID']>;
  type: AgendaItemType;
};

export class CreateProductInput {
  code: Scalars['String'];
  lotSize?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  stages?: InputMaybe<Array<CreateProductStageInput>>;
  status?: InputMaybe<ProductStatus>;
  viaType?: InputMaybe<ViaTypeProduct>;
};

export class CreateProductStageEquipmentInput {
  equipmentId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  productionHours?: InputMaybe<Scalars['Int']>;
};

export class CreateProductStageInput {
  equipments?: InputMaybe<Array<CreateProductStageEquipmentInput>>;
  order: Scalars['Int'];
  stageId: Scalars['ID'];
};

export class CreateStageInput {
  equipmentsIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StageStatus>;
};

export class CreateToolInput {
  codeIn?: InputMaybe<Scalars['String']>;
  codeSu?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<Scalars['String']>;
  drawer?: InputMaybe<Scalars['Float']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  maximumForce?: InputMaybe<Scalars['Float']>;
  normMatrix?: InputMaybe<Scalars['String']>;
  normType?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Scalars['String']>;
  productionQuantity?: InputMaybe<Scalars['Float']>;
  rotorId?: InputMaybe<Scalars['String']>;
  toolStatus?: InputMaybe<ToolStatus>;
};

export class CreateUnityInput {
  countryId: Scalars['String'];
  name: Scalars['String'];
  status?: InputMaybe<UnityStatus>;
};

export class CreateUserInput {
  costCenter: Scalars['String'];
  countryId: Scalars['String'];
  email: Scalars['String'];
  gender: UserGender;
  jobRoleId: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: InputMaybe<Scalars['String']>;
  profile?: UserProfile;
  re: Scalars['String'];
  status?: UserStatus;
  unityId: Scalars['String'];
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class DeleteSetupInput {
  setupItemId: Scalars['ID'];
};

export class EnumType {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export class Equipment {
  agendas?: Maybe<Array<ProductionAgenda>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipmentTools?: Maybe<Array<EquipmentTool>>;
  hasScale?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productStageEquipments?: Maybe<Array<ProductStageEquipment>>;
  sector?: Maybe<Sector>;
  sequenceStages?: Maybe<Array<SequenceStage>>;
  setupPartial?: Maybe<Scalars['Float']>;
  setupTotal?: Maybe<Scalars['Float']>;
  shiftsQuantity?: Maybe<Scalars['Float']>;
  stageEquipments?: Maybe<Array<StageEquipment>>;
  status: EquipmentStatus;
  tag?: Maybe<Scalars['String']>;
  timeEquipment?: Maybe<Scalars['Float']>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  viaType: ViaType;
};

export class EquipmentOptionDto {
  equipmentId: Scalars['ID'];
  equipmentName: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  productionHours?: Maybe<Scalars['Int']>;
  tools?: Maybe<Array<ToolOptionDto>>;
};

export class EquipmentOptionInRouteDto {
  equipmentId: Scalars['ID'];
  equipmentName: Scalars['String'];
  isAvailable: Scalars['Boolean'];
  isSelected: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  productionHours?: Maybe<Scalars['Int']>;
  selectedToolId?: Maybe<Scalars['ID']>;
  tools?: Maybe<Array<ToolOptionDto>>;
};

export class EquipmentPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Equipment>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Status do equipamento */
export enum EquipmentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class EquipmentTool {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment?: Maybe<Equipment>;
  id: Scalars['ID'];
  tool?: Maybe<Tool>;
  updatedAt: Scalars['DateTime'];
};

export class JobRole {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: JobRole;
};

export class LotEstimateDto {
  endDate: Scalars['DateTime'];
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
  startDate: Scalars['DateTime'];
  totalHours: Scalars['Int'];
};

export class LotStageChecklistDto {
  createdByName?: Maybe<Scalars['String']>;
  createdByPhotoUrl?: Maybe<Scalars['String']>;
  equipmentName: Scalars['String'];
  justification?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  plannedHours: Scalars['Int'];
  realFinishAt?: Maybe<Scalars['DateTime']>;
  realizedHours?: Maybe<Scalars['Int']>;
  stageIcon?: Maybe<Scalars['String']>;
  stageId: Scalars['ID'];
  stageName: Scalars['String'];
};

export class LotStageDetailDto {
  equipmentName: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  productionHours?: Maybe<Scalars['Int']>;
  stageIcon?: Maybe<Scalars['String']>;
  stageName: Scalars['String'];
};

export class LotStageExecutionUpsertInput {
  justification?: InputMaybe<Scalars['String']>;
  realFinishAt?: InputMaybe<Scalars['DateTime']>;
  realizedHours?: InputMaybe<Scalars['Int']>;
  stageId: Scalars['ID'];
};

/** Status do lote */
export enum LotStatus {
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED'
}

export class Mutation {
  addOccurrence: ProductionAgendaItem;
  applySequenceResequence: DefaultMessage;
  /** Create new Country */
  createCountry: Country;
  /** Create new Equipment */
  createEquipment: Equipment;
  /** Create new Product */
  createProduct: Product;
  /** Create new Stage */
  createStage: Stage;
  /** Create new Tool */
  createTool: Tool;
  /** Create new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  /** Delete Country by Id */
  deleteCountry: DefaultMessage;
  /** Delete Equipment by Id */
  deleteEquipment: DefaultMessage;
  /** Delete Product by Id */
  deleteProduct: DefaultMessage;
  deleteSetup: DefaultMessage;
  /** Delete Stage by Id */
  deleteStage: DefaultMessage;
  /** Delete Tool by Id */
  deleteTool: DefaultMessage;
  /** Delete Unity by Id */
  deleteUnity: DefaultMessage;
  /** Delete User by Id */
  deleteUser: DefaultMessage;
  login: AuthType;
  recalcAgenda: Scalars['Boolean'];
  removeOccurrence: DefaultMessage;
  saveSequenceLotChecklist: DefaultMessage;
  scheduleLotInAgenda: Array<ProductionAgendaItem>;
  scheduleSequence: ScheduledSequenceDto;
  sequenceProduct: SequenceProductOutput;
  /** Update Country By Id */
  updateCountry: Country;
  /** Update Equipment By Id */
  updateEquipment: Equipment;
  /** Update Product By Id */
  updateProduct: Product;
  updateSetupHours: DefaultMessage;
  /** Update Stage By Id */
  updateStage: Stage;
  /** Update Tool By Id */
  updateTool: Tool;
  /** Update Unity By Id */
  updateUnity: Unity;
  /** Update User by Id */
  updateUser: User;
};


export class MutationAddOccurrenceArgs {
  input: CreateOccurrenceInput;
};


export class MutationApplySequenceResequenceArgs {
  lotId: Scalars['ID'];
  newStartDate?: InputMaybe<Scalars['DateTime']>;
  selectedRouteNumber: Scalars['Float'];
  stageTools?: InputMaybe<Array<StageToolInput>>;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateEquipmentArgs {
  data: CreateEquipmentInput;
};


export class MutationCreateProductArgs {
  data: CreateProductInput;
};


export class MutationCreateStageArgs {
  data: CreateStageInput;
};


export class MutationCreateToolArgs {
  data: CreateToolInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationDeleteCountryArgs {
  id: Scalars['String'];
};


export class MutationDeleteEquipmentArgs {
  id: Scalars['String'];
};


export class MutationDeleteProductArgs {
  id: Scalars['String'];
};


export class MutationDeleteSetupArgs {
  input: DeleteSetupInput;
};


export class MutationDeleteStageArgs {
  id: Scalars['String'];
};


export class MutationDeleteToolArgs {
  id: Scalars['String'];
};


export class MutationDeleteUnityArgs {
  id: Scalars['String'];
};


export class MutationDeleteUserArgs {
  id: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationRecalcAgendaArgs {
  equipmentId: Scalars['String'];
  fromDate: Scalars['DateTime'];
};


export class MutationRemoveOccurrenceArgs {
  occurrenceId: Scalars['String'];
};


export class MutationSaveSequenceLotChecklistArgs {
  data: SaveLotChecklistInput;
};


export class MutationScheduleLotInAgendaArgs {
  input: ScheduleLotAgendaInput;
};


export class MutationScheduleSequenceArgs {
  data: ScheduleSequenceInput;
};


export class MutationSequenceProductArgs {
  data: SequenceProductInput;
};


export class MutationUpdateCountryArgs {
  data: UpdateCountryInput;
};


export class MutationUpdateEquipmentArgs {
  data: UpdateEquipmentInput;
};


export class MutationUpdateProductArgs {
  data: UpdateProductInput;
};


export class MutationUpdateSetupHoursArgs {
  input: UpdateSetupHoursInput;
};


export class MutationUpdateStageArgs {
  data: UpdateStageInput;
};


export class MutationUpdateToolArgs {
  data: UpdateToolInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
};

export class NormType {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: NormTypeStatus;
  updatedAt: Scalars['DateTime'];
};

/** Status da norma */
export enum NormTypeStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class Product {
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lotSize?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  productStages?: Maybe<Array<ProductStage>>;
  sequences?: Maybe<Array<Sequence>>;
  status: ProductStatus;
  updatedAt: Scalars['DateTime'];
  viaType: ViaTypeProduct;
};

export class ProductLastRouteInfoDto {
  code?: Maybe<Scalars['String']>;
  lastRoute?: Maybe<Scalars['Int']>;
  lotSize?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  previousEstimatedTime?: Maybe<Scalars['Int']>;
  productId: Scalars['ID'];
};

export class ProductPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Product>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class ProductStage {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipments?: Maybe<Array<ProductStageEquipment>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order: Scalars['Float'];
  product?: Maybe<Product>;
  stage?: Maybe<Stage>;
  updatedAt: Scalars['DateTime'];
};

export class ProductStageEquipment {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment: Equipment;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  productStage: ProductStage;
  productionHours?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

/** Status do produto */
export enum ProductStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class ProductionAgenda {
  capacityHours: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment: Equipment;
  id: Scalars['ID'];
  items?: Maybe<Array<ProductionAgendaItem>>;
  productionDate: Scalars['String'];
  scheduledHours: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export class ProductionAgendaItem {
  agenda: ProductionAgenda;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationHours: Scalars['Int'];
  endTime: Scalars['String'];
  id: Scalars['ID'];
  isAutomatic: Scalars['Boolean'];
  lot?: Maybe<SequenceLot>;
  occurrenceNotes?: Maybe<Array<AgendaOccurrenceNote>>;
  sequenceStage?: Maybe<SequenceStage>;
  setupDurationEdited: Scalars['Boolean'];
  setupGroupId?: Maybe<Scalars['String']>;
  setupLotCounter?: Maybe<Scalars['Int']>;
  setupManuallyRemoved: Scalars['Boolean'];
  setupNumber?: Maybe<Scalars['Int']>;
  setupOverrideHours?: Maybe<Scalars['Int']>;
  startTime: Scalars['String'];
  type: AgendaItemType;
  updatedAt: Scalars['DateTime'];
};

export class Query {
  /** Return Country by Id */
  countryById: Country;
  /** Return User Logged */
  currentUser: User;
  /** Return All By Type */
  enumByType: Array<EnumType>;
  /** Return Enum Type by Id */
  enumTypeById: EnumType;
  /** Return All Enum Types */
  enumTypes: Array<EnumType>;
  /** Return Equipment by Id */
  equipmentById: Equipment;
  getAgenda: Array<AgendaGridStageDto>;
  /** Return info last sequence by product */
  getProductLastRouteInfo: ProductLastRouteInfoDto;
  /** Return JobRole By ID */
  jobRoleById: JobRole;
  /** List All Job Roles */
  jobRoles: Array<JobRole>;
  /** Listar equipamentos que possuem agendamento */
  listAgendaEquipments: Array<AgendaEquipmentOptionDto>;
  /** Listar etapas que possuem agendamento */
  listAgendaStages: Array<AgendaStageOptionDto>;
  /** List All Country */
  listCountry: Array<Country>;
  /** List All Equipments */
  listEquipments: Array<Equipment>;
  /** List last Products created */
  listLastProducts: Array<Product>;
  /** List All NormType */
  listNormType: Array<NormType>;
  listOpNumbers: Array<Scalars['String']>;
  /** List All Products */
  listProducts: Array<Product>;
  /** List All Rotor */
  listRotor: Array<Rotor>;
  /** List All Sector */
  listSector: Array<Sector>;
  /** List All Stages */
  listStages: Array<Stage>;
  /** Return all stages active list for product */
  listStagesForProduct: Array<Stage>;
  /** List All Unity */
  listUnity: Array<Unity>;
  /** Return NormType by Id */
  normTypeById: NormType;
  /** Return Product by Id */
  productById: Product;
  /** Return Product Detail by Product Id */
  productDetail: Product;
  /** Return Rotor by Id */
  rotorById: Rotor;
  /** Return all countries paged */
  searchAllCountry: CountryPage;
  /** Return all tools paged */
  searchAllEquipment: EquipmentPage;
  /** Return all products paged */
  searchAllProduct: ProductPage;
  /** Return all stage paged */
  searchAllStage: StagePage;
  /** Return all tools paged */
  searchAllTool: ToolPage;
  /** Return all unities paged */
  searchAllUnity: UnityPage;
  /** Return All users paged */
  searchAllUser: UserPage;
  /** Return all equipments active list for product */
  searchEquipmentsForProduct: Array<Equipment>;
  /** Return all equipments active list for stage */
  searchEquipmentsForStage: Array<Equipment>;
  /** Return all products active list for sequence */
  searchProductsForSequence: Array<Product>;
  searchSequenceLots: SequenceLotPage;
  /** Return all tools active paged for equipment */
  searchToolForEquipment: ToolPage;
  /** Return Sector by Id */
  sectorById: Sector;
  sequenceLotChecklistDetail: SequenceLotChecklistDetailDto;
  sequenceLotDetail: SequenceLotDetailDto;
  sequenceLotResequenceDetail: SequenceLotResequenceDetailDto;
  /** Return Stage by Id */
  stageById: Stage;
  /** Return Tool by Id */
  toolById: Tool;
  /** Return Unity by Country Id */
  unityByCountryId: Array<Unity>;
  /** Return Unity by Id */
  unityById: Unity;
  /** Return User By Id */
  userById: User;
};


export class QueryCountryByIdArgs {
  id: Scalars['String'];
};


export class QueryEnumByTypeArgs {
  type: Scalars['String'];
};


export class QueryEnumTypeByIdArgs {
  id: Scalars['String'];
};


export class QueryEquipmentByIdArgs {
  id: Scalars['String'];
};


export class QueryGetAgendaArgs {
  input: RangeAgendaInput;
};


export class QueryGetProductLastRouteInfoArgs {
  productId: Scalars['String'];
};


export class QueryJobRoleByIdArgs {
  id: Scalars['String'];
};


export class QueryNormTypeByIdArgs {
  id: Scalars['String'];
};


export class QueryProductByIdArgs {
  id: Scalars['String'];
};


export class QueryProductDetailArgs {
  productId: Scalars['String'];
};


export class QueryRotorByIdArgs {
  id: Scalars['String'];
};


export class QuerySearchAllCountryArgs {
  data: SearchCountryInput;
};


export class QuerySearchAllEquipmentArgs {
  data: SearchEquipmentInput;
};


export class QuerySearchAllProductArgs {
  data: SearchProductInput;
};


export class QuerySearchAllStageArgs {
  data: SearchStageInput;
};


export class QuerySearchAllToolArgs {
  data: SearchToolInput;
};


export class QuerySearchAllUnityArgs {
  data: SearchUnityInput;
};


export class QuerySearchAllUserArgs {
  data: SearchUserInput;
};


export class QuerySearchEquipmentsForProductArgs {
  data: SearchEquipmentForProductInput;
};


export class QuerySearchEquipmentsForStageArgs {
  data: SearchEquipmentForStageInput;
};


export class QuerySearchProductsForSequenceArgs {
  data: SearchProductForSequenceInput;
};


export class QuerySearchSequenceLotsArgs {
  data: SearchSequenceLotInput;
};


export class QuerySearchToolForEquipmentArgs {
  data: SearchToolForEquipmentInput;
};


export class QuerySectorByIdArgs {
  id: Scalars['String'];
};


export class QuerySequenceLotChecklistDetailArgs {
  lotId: Scalars['String'];
};


export class QuerySequenceLotDetailArgs {
  lotId: Scalars['ID'];
};


export class QuerySequenceLotResequenceDetailArgs {
  lotId: Scalars['ID'];
};


export class QueryStageByIdArgs {
  id: Scalars['String'];
};


export class QueryToolByIdArgs {
  id: Scalars['String'];
};


export class QueryUnityByCountryIdArgs {
  countryId: Scalars['String'];
};


export class QueryUnityByIdArgs {
  id: Scalars['String'];
};


export class QueryUserByIdArgs {
  id: Scalars['String'];
};

export class RangeAgendaInput {
  end: Scalars['DateTime'];
  equipmentIds?: InputMaybe<Array<Scalars['String']>>;
  keyword?: InputMaybe<Scalars['String']>;
  opNumbers?: InputMaybe<Array<Scalars['String']>>;
  stageIds?: InputMaybe<Array<Scalars['String']>>;
  start: Scalars['DateTime'];
};

export class ResequenceLotEstimateDto {
  endDate: Scalars['DateTime'];
  lotCode: Scalars['String'];
  lotId: Scalars['String'];
  opNumber: Scalars['String'];
  startDate: Scalars['DateTime'];
  totalHours: Scalars['Int'];
};

export class ResequenceRouteDto {
  estimatedFinish: Scalars['DateTime'];
  lotEstimates: Array<ResequenceLotEstimateDto>;
  routeNumber: Scalars['Int'];
  stages: Array<ResequenceRouteStageDto>;
  totalHours: Scalars['Int'];
};

export class ResequenceRouteStageDto {
  options: Array<EquipmentOptionInRouteDto>;
  stageIcon?: Maybe<Scalars['String']>;
  stageId: Scalars['String'];
  stageName: Scalars['String'];
};

export class Rotor {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: RotorStatus;
  tool?: Maybe<Array<Tool>>;
  updatedAt: Scalars['DateTime'];
};

/** Status do rotor */
export enum RotorStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class RouteDto {
  estimatedFinish: Scalars['DateTime'];
  isAvailable: Scalars['Boolean'];
  lotEstimates: Array<LotEstimateDto>;
  routeNumber: Scalars['Int'];
  stages: Array<RouteStageDto>;
  totalHours: Scalars['Int'];
};

export class RouteStageDto {
  options: Array<EquipmentOptionInRouteDto>;
  stageIcon?: Maybe<Scalars['String']>;
  stageId: Scalars['ID'];
  stageName: Scalars['String'];
};

export class SaveLotChecklistInput {
  lotId: Scalars['ID'];
  lotRealFinishAt?: InputMaybe<Scalars['DateTime']>;
  stages: Array<LotStageExecutionUpsertInput>;
};

export class ScheduleLotAgendaInput {
  equipmentId: Scalars['ID'];
  lotId: Scalars['ID'];
  overrideDurationHours?: InputMaybe<Scalars['Int']>;
  sequenceStageId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export class ScheduleLotInput {
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
};

export class ScheduleSequenceInput {
  lots: Array<ScheduleLotInput>;
  productId: Scalars['ID'];
  selectedRouteNumber: Scalars['Float'];
  stageTools?: InputMaybe<Array<ScheduleStageToolInput>>;
  startDate: Scalars['DateTime'];
};

export class ScheduleStageToolInput {
  stageId: Scalars['ID'];
  toolId?: InputMaybe<Scalars['ID']>;
};

export class ScheduledSequenceDto {
  createdByName: Scalars['String'];
  estimatedFinish: Scalars['DateTime'];
  hoursPerProdDay: Scalars['Int'];
  id: Scalars['ID'];
  lots: Array<SequenceLotDto>;
  lotsCount: Scalars['Int'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  selectedRouteNumber: Scalars['Int'];
  stages: Array<SequenceStageSnapshotDto>;
  startDate: Scalars['DateTime'];
  status: SequenceStatus;
  totalHours: Scalars['Int'];
};

export class SearchCountryInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SearchEquipmentForProductInput {
  keyword?: InputMaybe<Scalars['String']>;
  stageId?: InputMaybe<Scalars['String']>;
};

export class SearchEquipmentForStageInput {
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchEquipmentInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchProductForSequenceInput {
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchProductInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchSequenceLotInput {
  end?: InputMaybe<Scalars['DateTime']>;
  equipmentId?: InputMaybe<Array<Scalars['ID']>>;
  keyword?: InputMaybe<Scalars['String']>;
  opNumbers?: InputMaybe<Array<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Array<Scalars['ID']>>;
  stageId?: InputMaybe<Array<Scalars['ID']>>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<LotStatus>>;
};

export class SearchStageInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchToolForEquipmentInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export class SearchToolInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchUnityInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchUserInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Array<Scalars['String']>>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Array<Scalars['String']>>;
};

export class Sector {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment?: Maybe<Array<Equipment>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: SectorStatus;
  updatedAt: Scalars['DateTime'];
};

/** Status do setor */
export enum SectorStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class Sequence {
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdByName: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimatedFinish: Scalars['DateTime'];
  hoursPerProdDay: Scalars['Float'];
  id: Scalars['ID'];
  lots?: Maybe<Array<SequenceLot>>;
  lotsCount: Scalars['Float'];
  product: Product;
  productName: Scalars['String'];
  selectedRouteNumber: Scalars['Float'];
  stages?: Maybe<Array<SequenceStage>>;
  startDate: Scalars['DateTime'];
  status: SequenceStatus;
  totalHours: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export class SequenceLot {
  agendaItems?: Maybe<Array<ProductionAgendaItem>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
  order: Scalars['Float'];
  sequence: Sequence;
  sequenceLotExecution?: Maybe<Array<SequenceLotExecution>>;
  startDate: Scalars['DateTime'];
  status: LotStatus;
  totalHours: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export class SequenceLotChecklistDetailDto {
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  lotCode: Scalars['String'];
  lotCreatedByName: Scalars['String'];
  lotCreatedByPhotoUrl?: Maybe<Scalars['String']>;
  opNumber: Scalars['String'];
  productName: Scalars['String'];
  routeNumber: Scalars['Int'];
  stages: Array<LotStageChecklistDto>;
  startDate: Scalars['DateTime'];
  status: LotStatus;
  totalPlannedHours: Scalars['Int'];
  totalRealizedHours?: Maybe<Scalars['Int']>;
};

export class SequenceLotDetailDto {
  createdByName: Scalars['String'];
  createdByPhotoUrl?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
  productName: Scalars['String'];
  routeNumber: Scalars['Int'];
  stages: Array<LotStageDetailDto>;
  startDate: Scalars['DateTime'];
  status: LotStatus;
  totalHours: Scalars['Int'];
};

export class SequenceLotDto {
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: LotStatus;
  totalHours: Scalars['Int'];
};

export class SequenceLotExecution {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  justification?: Maybe<Scalars['String']>;
  lot: SequenceLot;
  realFinishAt?: Maybe<Scalars['DateTime']>;
  realizedHours?: Maybe<Scalars['Int']>;
  stage: SequenceStage;
  updatedAt: Scalars['DateTime'];
};

export class SequenceLotListItem {
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
  productName: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: LotStatus;
};

export class SequenceLotPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<SequenceLotListItem>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class SequenceLotResequenceDetailDto {
  createdByName: Scalars['String'];
  currentRouteNumber: Scalars['Int'];
  lotId: Scalars['String'];
  productId: Scalars['String'];
  productName: Scalars['String'];
  routes: Array<ResequenceRouteDto>;
  sequenceId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export class SequenceProductInput {
  ops: Array<SequencerOpInput>;
  productId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export class SequenceProductOutput {
  createdByName: Scalars['String'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  routes: Array<RouteDto>;
  stages: Array<StageOptionsDto>;
  startDate: Scalars['DateTime'];
  summary: SequencingSummaryDto;
};

export class SequenceStage {
  agendaItems?: Maybe<Array<ProductionAgendaItem>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment: Equipment;
  equipmentId: Scalars['ID'];
  equipmentName: Scalars['String'];
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  productionHours?: Maybe<Scalars['Float']>;
  sequence: Sequence;
  sequenceLotExecution?: Maybe<Array<SequenceLotExecution>>;
  stage: Stage;
  stageIcon?: Maybe<Scalars['String']>;
  stageId: Scalars['ID'];
  stageName: Scalars['String'];
  tool?: Maybe<Tool>;
  toolId?: Maybe<Scalars['ID']>;
  toolLabel?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export class SequenceStageSnapshotDto {
  equipmentId: Scalars['ID'];
  equipmentName: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  productionHours?: Maybe<Scalars['Int']>;
  stageIcon?: Maybe<Scalars['String']>;
  stageId: Scalars['ID'];
  stageName: Scalars['String'];
  toolCodeIn?: Maybe<Scalars['String']>;
  toolCodeSu?: Maybe<Scalars['String']>;
  toolDimension?: Maybe<Scalars['String']>;
  toolId?: Maybe<Scalars['ID']>;
  toolLabel?: Maybe<Scalars['String']>;
};

/** Status da sequencia */
export enum SequenceStatus {
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED'
}

export class SequencerOpInput {
  lotCode: Scalars['String'];
  opNumber: Scalars['String'];
};

export class SequencingSummaryDto {
  availableRoutes: Scalars['Int'];
  bestRouteNumber: Scalars['Int'];
  maxTotalHours: Scalars['Int'];
  minTotalHours: Scalars['Int'];
  totalLots: Scalars['Int'];
  totalRoutes: Scalars['Int'];
  unavailableRoutes: Scalars['Int'];
  worstRouteNumber: Scalars['Int'];
};

export class Stage {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productStages?: Maybe<Array<ProductStage>>;
  sequenceStages?: Maybe<Array<SequenceStage>>;
  stageEquipments?: Maybe<Array<StageEquipment>>;
  status: StageStatus;
  updatedAt: Scalars['DateTime'];
};

export class StageEquipment {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment: Equipment;
  id: Scalars['ID'];
  stage: Stage;
  updatedAt: Scalars['DateTime'];
};

export class StageOptionsDto {
  options: Array<EquipmentOptionDto>;
  order: Scalars['Int'];
  productStageId: Scalars['ID'];
  stageIcon?: Maybe<Scalars['String']>;
  stageId: Scalars['ID'];
  stageName: Scalars['String'];
};

export class StagePage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Stage>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Status da etapa */
export enum StageStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class StageToolInput {
  stageId: Scalars['ID'];
  toolId?: InputMaybe<Scalars['ID']>;
};

export class Tool {
  codeIn?: Maybe<Scalars['String']>;
  codeSu?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dimension?: Maybe<Scalars['String']>;
  drawer?: Maybe<Scalars['Float']>;
  equipmentTool?: Maybe<Array<EquipmentTool>>;
  id: Scalars['ID'];
  manufacturer?: Maybe<Scalars['String']>;
  maximumForce?: Maybe<Scalars['Float']>;
  normMatrix?: Maybe<Scalars['String']>;
  normType?: Maybe<Scalars['String']>;
  observation?: Maybe<Scalars['String']>;
  productionQuantity?: Maybe<Scalars['Float']>;
  rotor?: Maybe<Rotor>;
  status: ToolStatus;
  updatedAt: Scalars['DateTime'];
};

export class ToolOptionDto {
  codeIn?: Maybe<Scalars['String']>;
  codeSu?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  toolId: Scalars['ID'];
};

export class ToolPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Tool>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Status da ferramenta */
export enum ToolStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class Unity {
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  equipment?: Maybe<Array<Equipment>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: UnityStatus;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
};

export class UnityPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Unity>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Status da unidade */
export enum UnityStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export class UpdateCountryInput {
  flag?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateEquipmentInput {
  hasScale?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  sectorId?: InputMaybe<Scalars['String']>;
  setupPartial?: InputMaybe<Scalars['Float']>;
  setupTotal?: InputMaybe<Scalars['Float']>;
  shiftsQuantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EquipmentStatus>;
  tag?: InputMaybe<Scalars['String']>;
  toolIds?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Scalars['String']>;
  viaType?: InputMaybe<ViaType>;
};

export class UpdateProductInput {
  code?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lotSize?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  stages?: InputMaybe<Array<UpdateProductStageInput>>;
  status?: InputMaybe<ProductStatus>;
  viaType?: InputMaybe<ViaTypeProduct>;
};

export class UpdateProductStageEquipmentInput {
  equipmentId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
  productionHours?: InputMaybe<Scalars['Int']>;
};

export class UpdateProductStageInput {
  equipments?: InputMaybe<Array<UpdateProductStageEquipmentInput>>;
  id?: InputMaybe<Scalars['ID']>;
  order: Scalars['Int'];
  stageId: Scalars['ID'];
};

export class UpdateSetupHoursInput {
  hours: Scalars['Int'];
  setupItemId: Scalars['ID'];
};

export class UpdateStageInput {
  equipmentsIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StageStatus>;
};

export class UpdateToolInput {
  codeIn?: InputMaybe<Scalars['String']>;
  codeSu?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<Scalars['String']>;
  drawer?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  manufacturer?: InputMaybe<Scalars['String']>;
  maximumForce?: InputMaybe<Scalars['Float']>;
  normMatrix?: InputMaybe<Scalars['String']>;
  normType?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Scalars['String']>;
  productionQuantity?: InputMaybe<Scalars['Float']>;
  rotorId?: InputMaybe<Scalars['String']>;
  toolStatus?: InputMaybe<ToolStatus>;
};

export class UpdateUnityInput {
  countryId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UnityStatus>;
};

export class UpdateUserInput {
  costCenter?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<UserGender>;
  id: Scalars['String'];
  jobRoleId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<UserProfile>;
  re?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class User {
  costCenter?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  createdSequences?: Maybe<Array<Sequence>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  gender: UserGender;
  id: Scalars['ID'];
  jobRole?: Maybe<JobRole>;
  name: Scalars['String'];
  occurrenceNotes?: Maybe<Array<AgendaOccurrenceNote>>;
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  profile: UserProfile;
  re: Scalars['String'];
  sequenceLotExecution?: Maybe<Array<SequenceLotExecution>>;
  status: UserStatus;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
};

/** Gênero do usuário */
export enum UserGender {
  F = 'F',
  M = 'M',
  O = 'O'
}

export class UserPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<User>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Perfil do usuário */
export enum UserProfile {
  Admin = 'ADMIN',
  User = 'USER'
}

/** Status do usuário */
export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** Tipo da Via */
export enum ViaType {
  Dry = 'DRY',
  Notapplicable = 'NOTAPPLICABLE',
  Wet = 'WET'
}

/** Tipo da Via do Produto */
export enum ViaTypeProduct {
  Dry = 'DRY',
  Notapplicable = 'NOTAPPLICABLE',
  Wet = 'WET'
}

export type AuthTypeFragment = { token: string, user: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type UserFragment = { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null };

export type DefaultMessageFragment = { message: string, status: number };

export type UnityPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null }> | null };

export type UnityFragment = { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null };

export type EnumTypeFragment = { id: string, type: string, value: string, description?: string | null, detail?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null };

export type CountryFragment = { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null };

export type UserPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null };

export type SequenceLotPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, opNumber: string, lotCode: string, productName: string, startDate: any, endDate: any, status: LotStatus }> | null };

export type SequenceLotListItemFragment = { id: string, opNumber: string, lotCode: string, productName: string, startDate: any, endDate: any, status: LotStatus };

export type SequenceLotDetailDtoFragment = { id: string, lotCode: string, opNumber: string, status: LotStatus, createdByName: string, createdByPhotoUrl?: string | null, productName: string, startDate: any, endDate: any, routeNumber: number, totalHours: number, stages: Array<{ order: number, stageName: string, stageIcon?: string | null, label?: string | null, equipmentName: string, productionHours?: number | null }> };

export type ProductFragment = { id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null };

export type CountryPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> | null };

export type SequenceProductOutputFragment = { productId: string, productName: string, startDate: any, createdByName: string, stages: Array<{ productStageId: string, stageId: string, stageName: string, stageIcon?: string | null, order: number, options: Array<{ equipmentId: string, equipmentName: string, label?: string | null, productionHours?: number | null, order: number, tools?: Array<{ label?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, toolId: string }> | null }> }>, routes: Array<{ routeNumber: number, isAvailable: boolean, totalHours: number, estimatedFinish: any, stages: Array<{ stageId: string, stageName: string, stageIcon?: string | null, options: Array<{ equipmentId: string, equipmentName: string, label?: string | null, productionHours?: number | null, isSelected: boolean, isAvailable: boolean, selectedToolId?: string | null, tools?: Array<{ label?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, toolId: string }> | null }> }>, lotEstimates: Array<{ lotCode: string, opNumber: string, startDate: any, endDate: any, totalHours: number }> }>, summary: { totalRoutes: number, totalLots: number, bestRouteNumber: number, worstRouteNumber: number, minTotalHours: number, maxTotalHours: number } };

export type ScheduledSequenceDtoFragment = { id: string, productId: string, productName: string, createdByName: string, startDate: any, estimatedFinish: any, selectedRouteNumber: number, totalHours: number, hoursPerProdDay: number, lotsCount: number, status: SequenceStatus, stages: Array<{ order: number, stageName: string, stageIcon?: string | null, label?: string | null, equipmentName: string, productionHours?: number | null }>, lots: Array<{ id: string, lotCode: string, opNumber: string, startDate: any, endDate: any, totalHours: number, status: LotStatus }> };

export type EquipmentFragment = { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null };

export type StageFragment = { id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null };

export type AgendaStageOptionDtoFragment = { id: string, name: string };

export type AgendaEquipmentOptionDtoFragment = { id: string, name: string };

export type AgendaGridStageDtoFragment = { stageId: string, stageName: string, stageIcon: string, stageOrder: number, equipments: Array<{ equipmentId: string, equipmentName: string, totalDaysWithOccurrence: number, totalOccurrenceHours: number, occurrences: Array<{ date: string, hours: number, title: string, notes: Array<{ createdAt: any, text: string, createdByName: string, createdByPhotoUrl?: string | null }> }>, days: Array<{ date: string, weekDay: string, month: string, blocks: Array<{ kind: string, title: string, itemType: AgendaItemType, equipmentId: string, equipmentName: string, totalHours: number, occurrenceId?: string | null, lines: Array<{ lotId?: string | null, lotCode?: string | null, opNumber?: string | null, description?: string | null, hours: number }> }> }> }> };

export type ProductionAgendaItemFragment = { id: string, type: AgendaItemType, description?: string | null, durationHours: number, startTime: string, endTime: string, createdAt: any, updatedAt: any, deletedAt?: any | null, agenda: { id: string, scheduledHours: number }, lot?: { id: string, status: LotStatus } | null, sequenceStage?: { id: string } | null, occurrenceNotes?: Array<{ id: string, text: string, createdAt: any, updatedAt: any, deletedAt?: any | null, agendaItem: { id: string } }> | null };

export type SequenceLotResequenceDetailDtoFragment = { lotId: string, sequenceId: string, productId: string, productName: string, createdByName: string, startDate: any, currentRouteNumber: number, routes: Array<{ routeNumber: number, totalHours: number, estimatedFinish: any, stages: Array<{ stageId: string, stageName: string, stageIcon?: string | null, options: Array<{ equipmentId: string, equipmentName: string, label?: string | null, productionHours?: number | null, isSelected: boolean, selectedToolId?: string | null, tools?: Array<{ label?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, toolId: string }> | null }> }>, lotEstimates: Array<{ lotCode: string, opNumber: string, startDate: any, endDate: any, totalHours: number }> }> };

export type ToolFragment = { id: string, manufacturer?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, normType?: string | null, productionQuantity?: number | null, maximumForce?: number | null, drawer?: number | null, normMatrix?: string | null, status: ToolStatus, observation?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, equipmentTool?: Array<{ id: string }> | null, rotor?: { id: string, name: string } | null };

export type ToolPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, manufacturer?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, normType?: string | null, productionQuantity?: number | null, maximumForce?: number | null, drawer?: number | null, normMatrix?: string | null, status: ToolStatus, observation?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, equipmentTool?: Array<{ id: string }> | null, rotor?: { id: string, name: string } | null }> | null };

export type StagePageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null }> | null };

export type EquipmentPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null }> | null };

export type ProductPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null }> | null };

export type ProductLastRouteInfoDtoFragment = { name?: string | null, lotSize?: number | null, code?: string | null, lastRoute?: number | null, previousEstimatedTime?: number | null, productId: string };

export type GetAgendaQueryVariables = Exact<{
  input: RangeAgendaInput;
}>;


export type GetAgendaQuery = { getAgenda: Array<{ stageId: string, stageName: string, stageIcon: string, stageOrder: number, equipments: Array<{ equipmentId: string, equipmentName: string, totalDaysWithOccurrence: number, totalOccurrenceHours: number, occurrences: Array<{ date: string, hours: number, title: string, notes: Array<{ createdAt: any, text: string, createdByName: string, createdByPhotoUrl?: string | null }> }>, days: Array<{ date: string, weekDay: string, month: string, blocks: Array<{ kind: string, title: string, itemType: AgendaItemType, equipmentId: string, equipmentName: string, totalHours: number, occurrenceId?: string | null, lines: Array<{ lotId?: string | null, lotCode?: string | null, opNumber?: string | null, description?: string | null, hours: number }> }> }> }> }> };

export type ListAgendaStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAgendaStagesQuery = { listAgendaStages: Array<{ id: string, name: string }> };

export type ListAgendaEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAgendaEquipmentsQuery = { listAgendaEquipments: Array<{ id: string, name: string }> };

export type SequenceLotResequenceDetailQueryVariables = Exact<{
  lotId: Scalars['ID'];
}>;


export type SequenceLotResequenceDetailQuery = { sequenceLotResequenceDetail: { lotId: string, sequenceId: string, productId: string, productName: string, createdByName: string, startDate: any, currentRouteNumber: number, routes: Array<{ routeNumber: number, totalHours: number, estimatedFinish: any, stages: Array<{ stageId: string, stageName: string, stageIcon?: string | null, options: Array<{ equipmentId: string, equipmentName: string, label?: string | null, productionHours?: number | null, isSelected: boolean, selectedToolId?: string | null, tools?: Array<{ label?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, toolId: string }> | null }> }>, lotEstimates: Array<{ lotCode: string, opNumber: string, startDate: any, endDate: any, totalHours: number }> }> } };

export type AddOccurrenceMutationVariables = Exact<{
  input: CreateOccurrenceInput;
}>;


export type AddOccurrenceMutation = { addOccurrence: { id: string, type: AgendaItemType, description?: string | null, durationHours: number, startTime: string, endTime: string, createdAt: any, updatedAt: any, deletedAt?: any | null, agenda: { id: string, scheduledHours: number }, lot?: { id: string, status: LotStatus } | null, sequenceStage?: { id: string } | null, occurrenceNotes?: Array<{ id: string, text: string, createdAt: any, updatedAt: any, deletedAt?: any | null, agendaItem: { id: string } }> | null } };

export type RemoveOccurrenceMutationVariables = Exact<{
  occurrenceId: Scalars['String'];
}>;


export type RemoveOccurrenceMutation = { removeOccurrence: { message: string, status: number } };

export type ApplySequenceResequenceMutationVariables = Exact<{
  lotId: Scalars['ID'];
  selectedRouteNumber: Scalars['Float'];
  stageTools?: InputMaybe<Array<StageToolInput> | StageToolInput>;
  newStartDate: Scalars['DateTime'];
}>;


export type ApplySequenceResequenceMutation = { applySequenceResequence: { message: string, status: number } };

export type JobRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type JobRolesQuery = { jobRoles: Array<{ id: string, name: string }> };

export type EnumByTypeQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type EnumByTypeQuery = { enumByType: Array<{ id: string, type: string, value: string, description?: string | null, detail?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> };

export type ListProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProductsQuery = { listProducts: Array<{ id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null }> };

export type ListSectorQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSectorQuery = { listSector: Array<{ id: string, name: string }> };

export type ListEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListEquipmentsQuery = { listEquipments: Array<{ id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null }> };

export type ListStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListStagesQuery = { listStages: Array<{ id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null }> };

export type ListNormTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type ListNormTypeQuery = { listNormType: Array<{ name: string, id: string }> };

export type ListOpNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOpNumbersQuery = { listOpNumbers: Array<string> };

export type ListCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCountryQuery = { listCountry: Array<{ id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> };

export type SearchAllCountryQueryVariables = Exact<{
  input: SearchCountryInput;
}>;


export type SearchAllCountryQuery = { searchAllCountry: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> | null } };

export type CreateCountryMutationVariables = Exact<{
  input: CreateCountryInput;
}>;


export type CreateCountryMutation = { createCountry: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } };

export type UpdateCountryMutationVariables = Exact<{
  input: UpdateCountryInput;
}>;


export type UpdateCountryMutation = { updateCountry: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } };

export type DeleteCountryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCountryMutation = { deleteCountry: { message: string, status: number } };

export type CreateEquipmentMutationVariables = Exact<{
  input: CreateEquipmentInput;
}>;


export type CreateEquipmentMutation = { createEquipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } };

export type UpdateEquipmentMutationVariables = Exact<{
  input: UpdateEquipmentInput;
}>;


export type UpdateEquipmentMutation = { updateEquipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } };

export type DeleteEquipmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEquipmentMutation = { deleteEquipment: { message: string, status: number } };

export type SearchToolForEquipmentQueryVariables = Exact<{
  input: SearchToolForEquipmentInput;
}>;


export type SearchToolForEquipmentQuery = { searchToolForEquipment: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, manufacturer?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, normType?: string | null, productionQuantity?: number | null, maximumForce?: number | null, drawer?: number | null, normMatrix?: string | null, status: ToolStatus, observation?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, equipmentTool?: Array<{ id: string }> | null, rotor?: { id: string, name: string } | null }> | null } };

export type SearchAllEquipmentQueryVariables = Exact<{
  input: SearchEquipmentInput;
}>;


export type SearchAllEquipmentQuery = { searchAllEquipment: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null }> | null } };

export type EquipmentByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EquipmentByIdQuery = { equipmentById: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } };

export type SearchAllProductQueryVariables = Exact<{
  input: SearchProductInput;
}>;


export type SearchAllProductQuery = { searchAllProduct: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null }> | null } };

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProductByIdQuery = { productById: { id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null } };

export type ListStagesForProductQueryVariables = Exact<{ [key: string]: never; }>;


export type ListStagesForProductQuery = { listStagesForProduct: Array<{ id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null }> };

export type SearchEquipmentsForProductQueryVariables = Exact<{
  input: SearchEquipmentForProductInput;
}>;


export type SearchEquipmentsForProductQuery = { searchEquipmentsForProduct: Array<{ id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null }> };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { createProduct: { id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { updateProduct: { id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null } };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProductMutation = { deleteProduct: { message: string, status: number } };

export type SearchSequenceLotsQueryVariables = Exact<{
  input: SearchSequenceLotInput;
}>;


export type SearchSequenceLotsQuery = { searchSequenceLots: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, opNumber: string, lotCode: string, productName: string, startDate: any, endDate: any, status: LotStatus }> | null } };

export type SequenceLotDetailQueryVariables = Exact<{
  lotId: Scalars['ID'];
}>;


export type SequenceLotDetailQuery = { sequenceLotDetail: { id: string, lotCode: string, opNumber: string, status: LotStatus, createdByName: string, createdByPhotoUrl?: string | null, productName: string, startDate: any, endDate: any, routeNumber: number, totalHours: number, stages: Array<{ order: number, stageName: string, stageIcon?: string | null, label?: string | null, equipmentName: string, productionHours?: number | null }> } };

export type SequenceProductMutationVariables = Exact<{
  input: SequenceProductInput;
}>;


export type SequenceProductMutation = { sequenceProduct: { productId: string, productName: string, startDate: any, createdByName: string, stages: Array<{ productStageId: string, stageId: string, stageName: string, stageIcon?: string | null, order: number, options: Array<{ equipmentId: string, equipmentName: string, label?: string | null, productionHours?: number | null, order: number, tools?: Array<{ label?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, toolId: string }> | null }> }>, routes: Array<{ routeNumber: number, isAvailable: boolean, totalHours: number, estimatedFinish: any, stages: Array<{ stageId: string, stageName: string, stageIcon?: string | null, options: Array<{ equipmentId: string, equipmentName: string, label?: string | null, productionHours?: number | null, isSelected: boolean, isAvailable: boolean, selectedToolId?: string | null, tools?: Array<{ label?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, toolId: string }> | null }> }>, lotEstimates: Array<{ lotCode: string, opNumber: string, startDate: any, endDate: any, totalHours: number }> }>, summary: { totalRoutes: number, totalLots: number, bestRouteNumber: number, worstRouteNumber: number, minTotalHours: number, maxTotalHours: number } } };

export type ScheduleSequenceMutationVariables = Exact<{
  input: ScheduleSequenceInput;
}>;


export type ScheduleSequenceMutation = { scheduleSequence: { id: string, productId: string, productName: string, createdByName: string, startDate: any, estimatedFinish: any, selectedRouteNumber: number, totalHours: number, hoursPerProdDay: number, lotsCount: number, status: SequenceStatus, stages: Array<{ order: number, stageName: string, stageIcon?: string | null, label?: string | null, equipmentName: string, productionHours?: number | null }>, lots: Array<{ id: string, lotCode: string, opNumber: string, startDate: any, endDate: any, totalHours: number, status: LotStatus }> } };

export type ListLastProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLastProductsQuery = { listLastProducts: Array<{ id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null }> };

export type SearchProductsForSequenceQueryVariables = Exact<{
  input: SearchProductForSequenceInput;
}>;


export type SearchProductsForSequenceQuery = { searchProductsForSequence: Array<{ id: string, status: ProductStatus, icon?: string | null, name: string, createdAt: any, updatedAt: any, lotSize?: number | null, deletedAt?: any | null, viaType: ViaTypeProduct, code?: string | null, sequences?: Array<{ id: string, productName: string }> | null, productStages?: Array<{ id: string, order: number, stage?: { id: string, name: string, status: StageStatus } | null, equipments?: Array<{ createdAt: any, deletedAt?: any | null, id: string, label?: string | null, order: number, productionHours?: number | null, updatedAt: any, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null }> | null }> };

export type GetProductLastRouteInfoQueryVariables = Exact<{
  productId: Scalars['String'];
}>;


export type GetProductLastRouteInfoQuery = { getProductLastRouteInfo: { name?: string | null, lotSize?: number | null, code?: string | null, lastRoute?: number | null, previousEstimatedTime?: number | null, productId: string } };

export type DeleteSetupMutationVariables = Exact<{
  input: DeleteSetupInput;
}>;


export type DeleteSetupMutation = { deleteSetup: { message: string, status: number } };

export type UpdateSetupHoursMutationVariables = Exact<{
  input: UpdateSetupHoursInput;
}>;


export type UpdateSetupHoursMutation = { updateSetupHours: { message: string, status: number } };

export type SearchAllStageQueryVariables = Exact<{
  input: SearchStageInput;
}>;


export type SearchAllStageQuery = { searchAllStage: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null }> | null } };

export type SearchEquipmentsForStageQueryVariables = Exact<{
  input: SearchEquipmentForStageInput;
}>;


export type SearchEquipmentsForStageQuery = { searchEquipmentsForStage: Array<{ id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null }> };

export type CreateStageMutationVariables = Exact<{
  input: CreateStageInput;
}>;


export type CreateStageMutation = { createStage: { id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null } };

export type UpdateStageMutationVariables = Exact<{
  input: UpdateStageInput;
}>;


export type UpdateStageMutation = { updateStage: { id: string, status: StageStatus, name: string, icon?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, status: EquipmentStatus, shiftsQuantity?: number | null, hasScale?: boolean | null, setupPartial?: number | null, setupTotal?: number | null, viaType: ViaType, name: string, timeEquipment?: number | null, tag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, sequenceStages?: Array<{ id: string, label?: string | null }> | null, equipmentTools?: Array<{ id: string, tool?: { dimension?: string | null, status: ToolStatus, productionQuantity?: number | null, maximumForce?: number | null, id: string, rotor?: { id: string, name: string } | null } | null }> | null, stageEquipments?: Array<{ id: string, equipment: { id: string, name: string } }> | null, unity?: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } | null, sector?: { id: string, name: string } | null, productStageEquipments?: Array<{ id: string, label?: string | null }> | null } }> | null, productStages?: Array<{ id: string, icon?: string | null, product?: { id: string, name: string } | null }> | null } };

export type DeleteStageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteStageMutation = { deleteStage: { message: string, status: number } };

export type ListRotorQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRotorQuery = { listRotor: Array<{ id: string, name: string }> };

export type CreateToolMutationVariables = Exact<{
  input: CreateToolInput;
}>;


export type CreateToolMutation = { createTool: { id: string, manufacturer?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, normType?: string | null, productionQuantity?: number | null, maximumForce?: number | null, drawer?: number | null, normMatrix?: string | null, status: ToolStatus, observation?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, equipmentTool?: Array<{ id: string }> | null, rotor?: { id: string, name: string } | null } };

export type UpdateToolMutationVariables = Exact<{
  input: UpdateToolInput;
}>;


export type UpdateToolMutation = { updateTool: { id: string, manufacturer?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, normType?: string | null, productionQuantity?: number | null, maximumForce?: number | null, drawer?: number | null, normMatrix?: string | null, status: ToolStatus, observation?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, equipmentTool?: Array<{ id: string }> | null, rotor?: { id: string, name: string } | null } };

export type DeleteToolMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteToolMutation = { deleteTool: { message: string, status: number } };

export type SearchAllToolQueryVariables = Exact<{
  input: SearchToolInput;
}>;


export type SearchAllToolQuery = { searchAllTool: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, manufacturer?: string | null, codeIn?: string | null, codeSu?: string | null, dimension?: string | null, normType?: string | null, productionQuantity?: number | null, maximumForce?: number | null, drawer?: number | null, normMatrix?: string | null, status: ToolStatus, observation?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, equipmentTool?: Array<{ id: string }> | null, rotor?: { id: string, name: string } | null }> | null } };

export type SearchAllUnityQueryVariables = Exact<{
  input: SearchUnityInput;
}>;


export type SearchAllUnityQuery = { searchAllUnity: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null }> | null } };

export type ListUnityQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUnityQuery = { listUnity: Array<{ id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null }> };

export type CreateUnityMutationVariables = Exact<{
  input: CreateUnityInput;
}>;


export type CreateUnityMutation = { createUnity: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } };

export type UpdateUnityMutationVariables = Exact<{
  input: UpdateUnityInput;
}>;


export type UpdateUnityMutation = { updateUnity: { id: string, name: string, status: UnityStatus, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, flag?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } };

export type DeleteUnityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUnityMutation = { deleteUnity: { message: string, status: number } };

export type LoginMutationVariables = Exact<{
  data: AuthInput;
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type SearchAllUserQueryVariables = Exact<{
  data: SearchUserInput;
}>;


export type SearchAllUserQuery = { searchAllUser: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null }> | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, name: string, email: string, re: string, phone: string, gender: UserGender, profile: UserProfile, status: UserStatus, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, jobRole?: { id: string, name: string } | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { deleteUser: { message: string, status: number } };

export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  re
  phone
  gender
  profile
  status
  costCenter
  photoUrl
  createdAt
  updatedAt
  deletedAt
  status
  country {
    id
    name
  }
  unity {
    id
    name
  }
  jobRole {
    id
    name
  }
}
    `;
export const AuthTypeFragmentDoc = gql`
    fragment AuthType on AuthType {
  token
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  name
  flag
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  status
  createdAt
  updatedAt
  deletedAt
  country {
    ...Country
  }
  user {
    ...User
  }
}
    ${CountryFragmentDoc}
${UserFragmentDoc}`;
export const UnityPageFragmentDoc = gql`
    fragment UnityPage on UnityPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;
export const EnumTypeFragmentDoc = gql`
    fragment EnumType on EnumType {
  id
  type
  value
  description
  detail
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UserPageFragmentDoc = gql`
    fragment UserPage on UserPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const SequenceLotListItemFragmentDoc = gql`
    fragment SequenceLotListItem on SequenceLotListItem {
  id
  opNumber
  lotCode
  productName
  startDate
  endDate
  status
}
    `;
export const SequenceLotPageFragmentDoc = gql`
    fragment SequenceLotPage on SequenceLotPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...SequenceLotListItem
  }
}
    ${SequenceLotListItemFragmentDoc}`;
export const SequenceLotDetailDtoFragmentDoc = gql`
    fragment SequenceLotDetailDto on SequenceLotDetailDto {
  id
  lotCode
  opNumber
  status
  createdByName
  createdByPhotoUrl
  productName
  startDate
  endDate
  routeNumber
  totalHours
  stages {
    order
    stageName
    stageIcon
    label
    equipmentName
    productionHours
  }
}
    `;
export const CountryPageFragmentDoc = gql`
    fragment CountryPage on CountryPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export const SequenceProductOutputFragmentDoc = gql`
    fragment SequenceProductOutput on SequenceProductOutput {
  productId
  productName
  startDate
  createdByName
  stages {
    productStageId
    stageId
    stageName
    stageIcon
    order
    options {
      equipmentId
      equipmentName
      label
      productionHours
      order
      tools {
        label
        codeIn
        codeSu
        dimension
        toolId
      }
    }
  }
  routes {
    routeNumber
    isAvailable
    stages {
      stageId
      stageName
      stageIcon
      options {
        equipmentId
        equipmentName
        label
        productionHours
        isSelected
        isAvailable
        tools {
          label
          codeIn
          codeSu
          dimension
          toolId
        }
        selectedToolId
      }
    }
    totalHours
    estimatedFinish
    lotEstimates {
      lotCode
      opNumber
      startDate
      endDate
      totalHours
    }
  }
  summary {
    totalRoutes
    totalLots
    bestRouteNumber
    worstRouteNumber
    minTotalHours
    maxTotalHours
  }
}
    `;
export const ScheduledSequenceDtoFragmentDoc = gql`
    fragment ScheduledSequenceDto on ScheduledSequenceDto {
  id
  productId
  productName
  createdByName
  startDate
  estimatedFinish
  selectedRouteNumber
  totalHours
  hoursPerProdDay
  lotsCount
  status
  stages {
    order
    stageName
    stageIcon
    label
    equipmentName
    productionHours
  }
  lots {
    id
    lotCode
    opNumber
    startDate
    endDate
    totalHours
    status
  }
}
    `;
export const AgendaStageOptionDtoFragmentDoc = gql`
    fragment AgendaStageOptionDto on AgendaStageOptionDto {
  id
  name
}
    `;
export const AgendaEquipmentOptionDtoFragmentDoc = gql`
    fragment AgendaEquipmentOptionDto on AgendaEquipmentOptionDto {
  id
  name
}
    `;
export const AgendaGridStageDtoFragmentDoc = gql`
    fragment AgendaGridStageDto on AgendaGridStageDto {
  stageId
  stageName
  stageIcon
  stageOrder
  equipments {
    equipmentId
    equipmentName
    totalDaysWithOccurrence
    totalOccurrenceHours
    occurrences {
      date
      hours
      title
      notes {
        createdAt
        text
        createdByName
        createdByPhotoUrl
      }
    }
    days {
      date
      weekDay
      month
      blocks {
        kind
        title
        itemType
        equipmentId
        equipmentName
        totalHours
        occurrenceId
        lines {
          lotId
          lotCode
          opNumber
          description
          hours
        }
      }
    }
  }
}
    `;
export const ProductionAgendaItemFragmentDoc = gql`
    fragment ProductionAgendaItem on ProductionAgendaItem {
  id
  agenda {
    id
    scheduledHours
  }
  type
  lot {
    id
    status
  }
  sequenceStage {
    id
  }
  description
  durationHours
  startTime
  endTime
  createdAt
  updatedAt
  deletedAt
  occurrenceNotes {
    id
    agendaItem {
      id
    }
    text
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export const SequenceLotResequenceDetailDtoFragmentDoc = gql`
    fragment SequenceLotResequenceDetailDto on SequenceLotResequenceDetailDto {
  lotId
  sequenceId
  productId
  productName
  createdByName
  startDate
  currentRouteNumber
  routes {
    routeNumber
    stages {
      stageId
      stageName
      stageIcon
      options {
        equipmentId
        equipmentName
        label
        productionHours
        isSelected
        tools {
          label
          codeIn
          codeSu
          dimension
          toolId
        }
        selectedToolId
      }
    }
    totalHours
    estimatedFinish
    lotEstimates {
      lotCode
      opNumber
      startDate
      endDate
      totalHours
    }
  }
}
    `;
export const ToolFragmentDoc = gql`
    fragment Tool on Tool {
  id
  manufacturer
  codeIn
  codeSu
  dimension
  normType
  productionQuantity
  maximumForce
  drawer
  normMatrix
  status
  observation
  equipmentTool {
    id
  }
  createdAt
  updatedAt
  deletedAt
  rotor {
    id
    name
  }
}
    `;
export const ToolPageFragmentDoc = gql`
    fragment ToolPage on ToolPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Tool
  }
}
    ${ToolFragmentDoc}`;
export const EquipmentFragmentDoc = gql`
    fragment Equipment on Equipment {
  id
  status
  shiftsQuantity
  hasScale
  setupPartial
  setupTotal
  viaType
  sequenceStages {
    id
    label
  }
  equipmentTools {
    id
    tool {
      dimension
      status
      rotor {
        id
        name
      }
      productionQuantity
      maximumForce
      id
    }
  }
  stageEquipments {
    id
    equipment {
      id
      name
    }
  }
  name
  timeEquipment
  tag
  createdAt
  updatedAt
  deletedAt
  unity {
    ...Unity
  }
  sector {
    id
    name
  }
  productStageEquipments {
    id
    label
  }
}
    ${UnityFragmentDoc}`;
export const StageFragmentDoc = gql`
    fragment Stage on Stage {
  id
  status
  name
  icon
  createdAt
  updatedAt
  deletedAt
  sequenceStages {
    id
    label
  }
  stageEquipments {
    id
    equipment {
      ...Equipment
    }
  }
  productStages {
    id
    icon
    product {
      id
      name
    }
  }
}
    ${EquipmentFragmentDoc}`;
export const StagePageFragmentDoc = gql`
    fragment StagePage on StagePage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Stage
  }
}
    ${StageFragmentDoc}`;
export const EquipmentPageFragmentDoc = gql`
    fragment EquipmentPage on EquipmentPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  status
  icon
  sequences {
    id
    productName
  }
  name
  createdAt
  updatedAt
  lotSize
  deletedAt
  viaType
  code
  productStages {
    id
    stage {
      id
      name
      status
    }
    equipments {
      createdAt
      deletedAt
      equipment {
        ...Equipment
      }
      id
      label
      order
      productionHours
      updatedAt
    }
    order
  }
}
    ${EquipmentFragmentDoc}`;
export const ProductPageFragmentDoc = gql`
    fragment ProductPage on ProductPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export const ProductLastRouteInfoDtoFragmentDoc = gql`
    fragment ProductLastRouteInfoDto on ProductLastRouteInfoDto {
  name
  lotSize
  code
  lastRoute
  previousEstimatedTime
  productId
}
    `;
export const GetAgendaDocument = gql`
    query getAgenda($input: RangeAgendaInput!) {
  getAgenda(input: $input) {
    ...AgendaGridStageDto
  }
}
    ${AgendaGridStageDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAgendaGQL extends Apollo.Query<GetAgendaQuery, GetAgendaQueryVariables> {
    document = GetAgendaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListAgendaStagesDocument = gql`
    query listAgendaStages {
  listAgendaStages {
    ...AgendaStageOptionDto
  }
}
    ${AgendaStageOptionDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListAgendaStagesGQL extends Apollo.Query<ListAgendaStagesQuery, ListAgendaStagesQueryVariables> {
    document = ListAgendaStagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListAgendaEquipmentsDocument = gql`
    query listAgendaEquipments {
  listAgendaEquipments {
    ...AgendaEquipmentOptionDto
  }
}
    ${AgendaEquipmentOptionDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListAgendaEquipmentsGQL extends Apollo.Query<ListAgendaEquipmentsQuery, ListAgendaEquipmentsQueryVariables> {
    document = ListAgendaEquipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SequenceLotResequenceDetailDocument = gql`
    query sequenceLotResequenceDetail($lotId: ID!) {
  sequenceLotResequenceDetail(lotId: $lotId) {
    ...SequenceLotResequenceDetailDto
  }
}
    ${SequenceLotResequenceDetailDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SequenceLotResequenceDetailGQL extends Apollo.Query<SequenceLotResequenceDetailQuery, SequenceLotResequenceDetailQueryVariables> {
    document = SequenceLotResequenceDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddOccurrenceDocument = gql`
    mutation addOccurrence($input: CreateOccurrenceInput!) {
  addOccurrence(input: $input) {
    ...ProductionAgendaItem
  }
}
    ${ProductionAgendaItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddOccurrenceGQL extends Apollo.Mutation<AddOccurrenceMutation, AddOccurrenceMutationVariables> {
    document = AddOccurrenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveOccurrenceDocument = gql`
    mutation removeOccurrence($occurrenceId: String!) {
  removeOccurrence(occurrenceId: $occurrenceId) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveOccurrenceGQL extends Apollo.Mutation<RemoveOccurrenceMutation, RemoveOccurrenceMutationVariables> {
    document = RemoveOccurrenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplySequenceResequenceDocument = gql`
    mutation applySequenceResequence($lotId: ID!, $selectedRouteNumber: Float!, $stageTools: [StageToolInput!], $newStartDate: DateTime!) {
  applySequenceResequence(
    lotId: $lotId
    selectedRouteNumber: $selectedRouteNumber
    stageTools: $stageTools
    newStartDate: $newStartDate
  ) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplySequenceResequenceGQL extends Apollo.Mutation<ApplySequenceResequenceMutation, ApplySequenceResequenceMutationVariables> {
    document = ApplySequenceResequenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobRolesDocument = gql`
    query jobRoles {
  jobRoles {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobRolesGQL extends Apollo.Query<JobRolesQuery, JobRolesQueryVariables> {
    document = JobRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnumByTypeDocument = gql`
    query enumByType($input: String!) {
  enumByType(type: $input) {
    ...EnumType
  }
}
    ${EnumTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnumByTypeGQL extends Apollo.Query<EnumByTypeQuery, EnumByTypeQueryVariables> {
    document = EnumByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListProductsDocument = gql`
    query listProducts {
  listProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListProductsGQL extends Apollo.Query<ListProductsQuery, ListProductsQueryVariables> {
    document = ListProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListSectorDocument = gql`
    query listSector {
  listSector {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListSectorGQL extends Apollo.Query<ListSectorQuery, ListSectorQueryVariables> {
    document = ListSectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListEquipmentsDocument = gql`
    query listEquipments {
  listEquipments {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListEquipmentsGQL extends Apollo.Query<ListEquipmentsQuery, ListEquipmentsQueryVariables> {
    document = ListEquipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListStagesDocument = gql`
    query listStages {
  listStages {
    ...Stage
  }
}
    ${StageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListStagesGQL extends Apollo.Query<ListStagesQuery, ListStagesQueryVariables> {
    document = ListStagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListNormTypeDocument = gql`
    query listNormType {
  listNormType {
    name
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListNormTypeGQL extends Apollo.Query<ListNormTypeQuery, ListNormTypeQueryVariables> {
    document = ListNormTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListOpNumbersDocument = gql`
    query listOpNumbers {
  listOpNumbers
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListOpNumbersGQL extends Apollo.Query<ListOpNumbersQuery, ListOpNumbersQueryVariables> {
    document = ListOpNumbersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCountryDocument = gql`
    query listCountry {
  listCountry {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCountryGQL extends Apollo.Query<ListCountryQuery, ListCountryQueryVariables> {
    document = ListCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllCountryDocument = gql`
    query searchAllCountry($input: SearchCountryInput!) {
  searchAllCountry(data: $input) {
    ...CountryPage
  }
}
    ${CountryPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllCountryGQL extends Apollo.Query<SearchAllCountryQuery, SearchAllCountryQueryVariables> {
    document = SearchAllCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCountryDocument = gql`
    mutation createCountry($input: CreateCountryInput!) {
  createCountry(data: $input) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCountryGQL extends Apollo.Mutation<CreateCountryMutation, CreateCountryMutationVariables> {
    document = CreateCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCountryDocument = gql`
    mutation updateCountry($input: UpdateCountryInput!) {
  updateCountry(data: $input) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCountryGQL extends Apollo.Mutation<UpdateCountryMutation, UpdateCountryMutationVariables> {
    document = UpdateCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCountryDocument = gql`
    mutation deleteCountry($id: String!) {
  deleteCountry(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCountryGQL extends Apollo.Mutation<DeleteCountryMutation, DeleteCountryMutationVariables> {
    document = DeleteCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEquipmentDocument = gql`
    mutation createEquipment($input: CreateEquipmentInput!) {
  createEquipment(data: $input) {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEquipmentGQL extends Apollo.Mutation<CreateEquipmentMutation, CreateEquipmentMutationVariables> {
    document = CreateEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEquipmentDocument = gql`
    mutation updateEquipment($input: UpdateEquipmentInput!) {
  updateEquipment(data: $input) {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEquipmentGQL extends Apollo.Mutation<UpdateEquipmentMutation, UpdateEquipmentMutationVariables> {
    document = UpdateEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEquipmentDocument = gql`
    mutation deleteEquipment($id: String!) {
  deleteEquipment(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEquipmentGQL extends Apollo.Mutation<DeleteEquipmentMutation, DeleteEquipmentMutationVariables> {
    document = DeleteEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchToolForEquipmentDocument = gql`
    query searchToolForEquipment($input: SearchToolForEquipmentInput!) {
  searchToolForEquipment(data: $input) {
    ...ToolPage
  }
}
    ${ToolPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchToolForEquipmentGQL extends Apollo.Query<SearchToolForEquipmentQuery, SearchToolForEquipmentQueryVariables> {
    document = SearchToolForEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllEquipmentDocument = gql`
    query searchAllEquipment($input: SearchEquipmentInput!) {
  searchAllEquipment(data: $input) {
    ...EquipmentPage
  }
}
    ${EquipmentPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllEquipmentGQL extends Apollo.Query<SearchAllEquipmentQuery, SearchAllEquipmentQueryVariables> {
    document = SearchAllEquipmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentByIdDocument = gql`
    query equipmentById($id: String!) {
  equipmentById(id: $id) {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentByIdGQL extends Apollo.Query<EquipmentByIdQuery, EquipmentByIdQueryVariables> {
    document = EquipmentByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllProductDocument = gql`
    query searchAllProduct($input: SearchProductInput!) {
  searchAllProduct(data: $input) {
    ...ProductPage
  }
}
    ${ProductPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllProductGQL extends Apollo.Query<SearchAllProductQuery, SearchAllProductQueryVariables> {
    document = SearchAllProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductByIdDocument = gql`
    query productById($id: String!) {
  productById(id: $id) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductByIdGQL extends Apollo.Query<ProductByIdQuery, ProductByIdQueryVariables> {
    document = ProductByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListStagesForProductDocument = gql`
    query listStagesForProduct {
  listStagesForProduct {
    ...Stage
  }
}
    ${StageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListStagesForProductGQL extends Apollo.Query<ListStagesForProductQuery, ListStagesForProductQueryVariables> {
    document = ListStagesForProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchEquipmentsForProductDocument = gql`
    query searchEquipmentsForProduct($input: SearchEquipmentForProductInput!) {
  searchEquipmentsForProduct(data: $input) {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchEquipmentsForProductGQL extends Apollo.Query<SearchEquipmentsForProductQuery, SearchEquipmentsForProductQueryVariables> {
    document = SearchEquipmentsForProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(data: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductGQL extends Apollo.Mutation<CreateProductMutation, CreateProductMutationVariables> {
    document = CreateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(data: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductGQL extends Apollo.Mutation<UpdateProductMutation, UpdateProductMutationVariables> {
    document = UpdateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: String!) {
  deleteProduct(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductGQL extends Apollo.Mutation<DeleteProductMutation, DeleteProductMutationVariables> {
    document = DeleteProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSequenceLotsDocument = gql`
    query searchSequenceLots($input: SearchSequenceLotInput!) {
  searchSequenceLots(data: $input) {
    ...SequenceLotPage
  }
}
    ${SequenceLotPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSequenceLotsGQL extends Apollo.Query<SearchSequenceLotsQuery, SearchSequenceLotsQueryVariables> {
    document = SearchSequenceLotsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SequenceLotDetailDocument = gql`
    query sequenceLotDetail($lotId: ID!) {
  sequenceLotDetail(lotId: $lotId) {
    ...SequenceLotDetailDto
  }
}
    ${SequenceLotDetailDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SequenceLotDetailGQL extends Apollo.Query<SequenceLotDetailQuery, SequenceLotDetailQueryVariables> {
    document = SequenceLotDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SequenceProductDocument = gql`
    mutation sequenceProduct($input: SequenceProductInput!) {
  sequenceProduct(data: $input) {
    ...SequenceProductOutput
  }
}
    ${SequenceProductOutputFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SequenceProductGQL extends Apollo.Mutation<SequenceProductMutation, SequenceProductMutationVariables> {
    document = SequenceProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleSequenceDocument = gql`
    mutation scheduleSequence($input: ScheduleSequenceInput!) {
  scheduleSequence(data: $input) {
    ...ScheduledSequenceDto
  }
}
    ${ScheduledSequenceDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleSequenceGQL extends Apollo.Mutation<ScheduleSequenceMutation, ScheduleSequenceMutationVariables> {
    document = ScheduleSequenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListLastProductsDocument = gql`
    query listLastProducts {
  listLastProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListLastProductsGQL extends Apollo.Query<ListLastProductsQuery, ListLastProductsQueryVariables> {
    document = ListLastProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProductsForSequenceDocument = gql`
    query searchProductsForSequence($input: SearchProductForSequenceInput!) {
  searchProductsForSequence(data: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProductsForSequenceGQL extends Apollo.Query<SearchProductsForSequenceQuery, SearchProductsForSequenceQueryVariables> {
    document = SearchProductsForSequenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductLastRouteInfoDocument = gql`
    query getProductLastRouteInfo($productId: String!) {
  getProductLastRouteInfo(productId: $productId) {
    ...ProductLastRouteInfoDto
  }
}
    ${ProductLastRouteInfoDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductLastRouteInfoGQL extends Apollo.Query<GetProductLastRouteInfoQuery, GetProductLastRouteInfoQueryVariables> {
    document = GetProductLastRouteInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSetupDocument = gql`
    mutation deleteSetup($input: DeleteSetupInput!) {
  deleteSetup(input: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSetupGQL extends Apollo.Mutation<DeleteSetupMutation, DeleteSetupMutationVariables> {
    document = DeleteSetupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSetupHoursDocument = gql`
    mutation updateSetupHours($input: UpdateSetupHoursInput!) {
  updateSetupHours(input: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSetupHoursGQL extends Apollo.Mutation<UpdateSetupHoursMutation, UpdateSetupHoursMutationVariables> {
    document = UpdateSetupHoursDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllStageDocument = gql`
    query searchAllStage($input: SearchStageInput!) {
  searchAllStage(data: $input) {
    ...StagePage
  }
}
    ${StagePageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllStageGQL extends Apollo.Query<SearchAllStageQuery, SearchAllStageQueryVariables> {
    document = SearchAllStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchEquipmentsForStageDocument = gql`
    query searchEquipmentsForStage($input: SearchEquipmentForStageInput!) {
  searchEquipmentsForStage(data: $input) {
    ...Equipment
  }
}
    ${EquipmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchEquipmentsForStageGQL extends Apollo.Query<SearchEquipmentsForStageQuery, SearchEquipmentsForStageQueryVariables> {
    document = SearchEquipmentsForStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStageDocument = gql`
    mutation createStage($input: CreateStageInput!) {
  createStage(data: $input) {
    ...Stage
  }
}
    ${StageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStageGQL extends Apollo.Mutation<CreateStageMutation, CreateStageMutationVariables> {
    document = CreateStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStageDocument = gql`
    mutation updateStage($input: UpdateStageInput!) {
  updateStage(data: $input) {
    ...Stage
  }
}
    ${StageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStageGQL extends Apollo.Mutation<UpdateStageMutation, UpdateStageMutationVariables> {
    document = UpdateStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStageDocument = gql`
    mutation deleteStage($id: String!) {
  deleteStage(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStageGQL extends Apollo.Mutation<DeleteStageMutation, DeleteStageMutationVariables> {
    document = DeleteStageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListRotorDocument = gql`
    query listRotor {
  listRotor {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListRotorGQL extends Apollo.Query<ListRotorQuery, ListRotorQueryVariables> {
    document = ListRotorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateToolDocument = gql`
    mutation createTool($input: CreateToolInput!) {
  createTool(data: $input) {
    ...Tool
  }
}
    ${ToolFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateToolGQL extends Apollo.Mutation<CreateToolMutation, CreateToolMutationVariables> {
    document = CreateToolDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateToolDocument = gql`
    mutation updateTool($input: UpdateToolInput!) {
  updateTool(data: $input) {
    ...Tool
  }
}
    ${ToolFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateToolGQL extends Apollo.Mutation<UpdateToolMutation, UpdateToolMutationVariables> {
    document = UpdateToolDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteToolDocument = gql`
    mutation deleteTool($id: String!) {
  deleteTool(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteToolGQL extends Apollo.Mutation<DeleteToolMutation, DeleteToolMutationVariables> {
    document = DeleteToolDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllToolDocument = gql`
    query searchAllTool($input: SearchToolInput!) {
  searchAllTool(data: $input) {
    ...ToolPage
  }
}
    ${ToolPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllToolGQL extends Apollo.Query<SearchAllToolQuery, SearchAllToolQueryVariables> {
    document = SearchAllToolDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllUnityDocument = gql`
    query searchAllUnity($input: SearchUnityInput!) {
  searchAllUnity(data: $input) {
    ...UnityPage
  }
}
    ${UnityPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllUnityGQL extends Apollo.Query<SearchAllUnityQuery, SearchAllUnityQueryVariables> {
    document = SearchAllUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUnityDocument = gql`
    query listUnity {
  listUnity {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUnityGQL extends Apollo.Query<ListUnityQuery, ListUnityQueryVariables> {
    document = ListUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnityDocument = gql`
    mutation createUnity($input: CreateUnityInput!) {
  createUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUnityGQL extends Apollo.Mutation<CreateUnityMutation, CreateUnityMutationVariables> {
    document = CreateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnityDocument = gql`
    mutation updateUnity($input: UpdateUnityInput!) {
  updateUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnityGQL extends Apollo.Mutation<UpdateUnityMutation, UpdateUnityMutationVariables> {
    document = UpdateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUnityDocument = gql`
    mutation deleteUnity($id: String!) {
  deleteUnity(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnityGQL extends Apollo.Mutation<DeleteUnityMutation, DeleteUnityMutationVariables> {
    document = DeleteUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation login($data: AuthInput!) {
  login(data: $data) {
    ...AuthType
  }
}
    ${AuthTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllUserDocument = gql`
    query searchAllUser($data: SearchUserInput!) {
  searchAllUser(data: $data) {
    ...UserPage
  }
}
    ${UserPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllUserGQL extends Apollo.Query<SearchAllUserQuery, SearchAllUserQueryVariables> {
    document = SearchAllUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($data: CreateUserInput!) {
  createUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }